<template>
	<div v-if="jobProfileData" class="job-listing--item-head-short-info" @click.prevent="goToEditPage">
		<div class="profile-view">
			<div class="tag-sections">
				<section>
					<div class="sub-sections">
						<div class="sub-section">
							<Salary
								v-if="jobProfileData.salary"
								:data="jobProfileData.salary"
								:with-collective="false"
								class="inline"
							/>
							<HourlyRate
								v-else-if="jobProfileData.hourlyRate"
								:data="jobProfileData.hourlyRate"
								label="Stundensatz"
								class="inline"
							/>
							<div v-if="employmentMode" class="sub-values inline">
								<div class="sub-value">
									<div class="label">Beschäftigungsart</div>
									<div>
										<Label
											:characteristic="employmentMode"
											:label-type="labelTypeJobProfile"
											:max-item-length="20"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import Salary from "@/vue/customer-area/job-profile/edit-display/Salary.vue";
import HourlyRate from "@/vue/customer-area/job-profile/edit-display/HourlyRate.vue";
import {prepare} from "@/helper/job-profile/PreFillPreparation";
import {mapState} from "vuex";
import {JOB_PROFILE} from "@/helper/characteristic/Label";
import _ from "lodash";
import Label from "@/vue/characteristic/Label.vue";

export default {
	components: {HourlyRate, Label, Salary},

	props: {
		jobProfile: {
			type: Object,
			required: true,
		}
	},

	mounted ()
	{
		this.jobProfileData = prepare(this.jobProfile, this.meta);
	},

	data ()
	{
		return {
			jobProfileData: undefined,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		employmentMode ()
		{
			return _.first(this.jobProfileData.employmentMode)?.item;
		},
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		},
	},

	methods: {
		goToEditPage ()
		{
			location.href = '/kundenbereich/jobs/' + this.jobProfile.id + '/bearbeiten';
		}
	}
}
</script>
